import {
  GoogleSitesLink,
  CanvaLink,
  CitrixWebExLink,
  IMovieLink,
  Molenda2007Link,
  Morrison2013Link,
} from '../../common/links'

const data = {
  titleMain: 'Integrated Multimedia Project',
  courseNumber: 'EDET 603',
  projectLink: 'https://sites.google.com/view/teacher-confessions/home',
  standardName: 'AECT 1 – Content Knowledge',
  standardSummary:
    'Candidates demonstrate the knowledge necessary to create, use, assess, and manage theoretical and practical applications of educational technologies and processes.',
  contextAndConditions:
    'During the Fall 2019 Design and Development Tools I (EDET 603) course with Dr. Erin Besser, we studied multimedia elements, including the creation and editing of materials with exploration of Instructional applications, copyright issues, and technology limitations.',
  scope:
    'For the Integrated Multimedia Project (IMP), I worked with a classmate (Daniel Berg) to collaboratively plan, design and develop a dynamic multimedia project which included a podcast episode, vodcast, marketing poster, cover art, and website.',
  role:
    'Since both Daniel and I were previously public school teachers, we served as Subject Matter Experts for the “Confessions of an Ex. Teacher” IMP. I was the instructional designer and developer of the vodcast, marketing poster, and covert art, and we both participated in the recording of the podcast and vodcast.',
  instructionalDesign: `Following ADDIE (${Molenda2007Link}) and MRK (${Morrison2013Link}) instructional design models, we first analyzed content that would be helpful for our target audience of current or former K-12 classroom teachers, which included determining instructional problems, identifying learner characteristics, and analyzing task components. We then designed scripts for the podcast and vodcast, which included defining instructional objectives, structuring content sequentially, designing instructional strategies, and planning the instructional message and mode of delivery. Then we developed the recordings and marketing materials and implemented them into a publicly available website. Finally, we evaluated the project based on feedback from peer reviewers in the class.`,
  performanceIndicator: [
    {
      title: 'Creating',
      indicator:
        'Candidates demonstrate the ability to create instructional materials and learning environments using a variety of systems approaches.',
      implementation:
        'We created instructional materials (podcast, vodcast, marketing poster and cover art) and created a website to make the materials publicly accessible online.',
    },
    {
      title: 'Using',
      indicator:
        'Candidates demonstrate the ability to select and use technological resources and processes to support student learning and to enhance their pedagogy.',
      implementation: `We selected and used ${GoogleSitesLink} (website), ${CanvaLink} (cover art, marketing poster), ${CitrixWebExLink} (recording tool), and ${IMovieLink} (vodcast/podcast production).`,
    },
    {
      title: 'Assessing/Evaluating',
      indicator:
        'Candidates demonstrate the ability to assess and evaluate the effective integration of appropriate technologies and instructional materials.',
      implementation:
        'We reviewed available technology resources in order to determine those most effective for developing the instructional materials.',
    },
    {
      title: 'Managing',
      indicator:
        'Candidates demonstrate the ability to effectively manage people, processes, physical infrastructures, and financial resources to achieve predetermined goals.',
      implementation:
        'At the beginning of the project, roles and tasks for each team member were clearly communicated and deadlines were established based on the course schedule. Frequent communication and virtual meetings were used throughout the project to effectively manage process.',
    },
    {
      title: 'Ethics',
      indicator:
        'Candidates demonstrate the contemporary professional ethics of the field as defined and developed by the Association for Educational Communications and Technology.',
      implementation: 'Resources and references were appropriately cited.',
    },
  ],
  reflection:
    'Since I was not familiar with the process for developing a vodcast, I learned how to utilize a storyboard for the development stage. In addition, I had not created cover art and enjoyed exploring the features available in Canva. Looking back now, I would have spent more time testing the recording program and equipment in order to make improvements to the sound quality for both the vodcast and podcast. Since many of the technological resources and processes were new for us, the artifact demonstrates application of our newly acquired knowledge and skills.',
}

export default data
